module.exports = __webpack_public_path__ + "static/media/supprimer-cercle.e2ab78fd.png";